// Pure derivations consumed by the DC chart components (the filter / suspicion-level /
// job-control derivations by Controls.jsx). Extracted from the legacy block.coffee render()
// body so the math is independently testable and the React components stay render-only.

const passesScoreGate = ({ s, suspicionLevel, suspicionScores, vectors, disabledVectors }) =>
  suspicionLevel <= suspicionScores[s[0]] &&
  s.slice(1).some((v, i) => !disabledVectors.includes(vectors[i].id) && 0 < v)

const passesFilterGate = ({ uid, filter, quarantineUIDs }) => {
  if ('quarantined' === filter) return quarantineUIDs.includes(uid)
  if ('flagged' === filter) return !quarantineUIDs.includes(uid)
  return true
}

export const deriveFilterOptions = ({
  scores,
  suspicionScores,
  suspicionLevel,
  vectors,
  disabledVectors,
  quarantineUIDs
}) => {
  const filteredScores = scores.filter(s =>
    passesScoreGate({ s, suspicionLevel, suspicionScores, vectors, disabledVectors })
  )

  const filteredQuarantineUIDs = quarantineUIDs.filter(uid => {
    const s = scores.find(score => score[0] === uid)
    return Boolean(s) && passesScoreGate({ s, suspicionLevel, suspicionScores, vectors, disabledVectors })
  })

  return [
    { key: 'all', text: 'All flagged', l: filteredScores.length, tag: 'span' },
    { key: 'quarantined', text: 'Quarantined', l: filteredQuarantineUIDs.length, tag: 'span' },
    { key: 'flagged', text: 'Not quarantined', l: filteredScores.length - filteredQuarantineUIDs.length, tag: 'span' }
  ]
}

export const deriveSuspicionLevelOptions = ({
  scores,
  suspicionScores,
  suspicionLevels,
  vectors,
  disabledVectors,
  quarantineUIDs,
  filter
}) =>
  suspicionLevels.map((cur, index) => {
    const l = scores.filter(s => {
      if (cur[1] > suspicionScores[s[0]]) return false
      if (!s.slice(1).some((v, i) => !disabledVectors.includes(vectors[i].id) && 0 < v)) return false
      return passesFilterGate({ uid: s[0], filter, quarantineUIDs })
    }).length

    // The two highest-suspicion buckets render with `<b>` markup; the rest plain.
    return { text: cur[0], key: cur[1], l, tag: index < 2 ? 'b' : 'span' }
  })

export const deriveJobControls = ({ job, model }) => ({
  message: job.message || '',
  dcLastRunTs: model.dcLastRunTs,
  dcAnalyzedCount: model.dcAnalyzedCount,
  notAnalyzedCount: model.notAnalyzedCount,
  disabled: 'idle' !== job.status
})
